import {
  getOrFetchKnowledgeBaseId,
  getOrFetchKnowledgeBaseConfig,
} from 'core_main/api/knowledge_bases';
import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import { constructKnowledgeBaseConfigCallbackResponse } from './helpers';
import { GetKnowledgeBaseConfigCallbackResponse } from './types';

export const getKnowledgeBaseConfig = (cb?: PublicCallback) => {
  return getOrFetchKnowledgeBaseId()
    .then((id) => {
      return getOrFetchKnowledgeBaseConfig({
        knowledgeBaseId: id,
      }).then((config) => {
        const callbackResponse: GetKnowledgeBaseConfigCallbackResponse =
          constructKnowledgeBaseConfigCallbackResponse(config);
        if (typeof cb === 'function') {
          cb(callbackResponse);
        }
        return callbackResponse;
      });
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, {
        message: 'Failed to get knowledge base information',
      });
      return {};
    });
};
